import { Component } from '@angular/core';

@Component({
  selector: 'c2h-document-home',
  templateUrl: './document-home.component.html',
})
export class DocumentHomeComponent {}
